import React, { useRef } from 'react';
import { Download, Printer } from 'lucide-react';
import html2pdf from 'html2pdf.js';
import { useLanguage } from '../context/LanguageContext';

const JanmMrutyuNondvahiAnuplabdhataForm = () => {
  const { language } = useLanguage();
  const componentRef = useRef();

  const handlePrint = () => {
    window.print();
  };

  const handleDownloadPdf = () => {
    const element = componentRef.current;
    const opt = {
      margin: 0,
      filename: language === 'marathi' ? 'Janm_Mrutyu_Nondvahi_Anuplabdhata_Pramanpatra.pdf' : 'Non_Availability_Birth_Death_Register_Certificate.pdf',
      image: { type: 'jpeg', quality: 1 },
      html2canvas: { scale: 3, useCORS: true, logging: false },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
    };
    html2pdf().from(element).set(opt).save();
  };

  return (
    <div className="min-h-screen bg-gray-200 py-8 font-sans print:py-0 print:bg-white flex flex-col items-center">
      <style>
        {`
          @media print {
            @page {
              size: A4 portrait;
              margin: 0mm;
            }
            body {
              background-color: white !important;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }
          }
        `}
      </style>
      
      {/* Controls Container */}
      <div className="w-full max-w-[210mm] mb-6 flex justify-end space-x-4 print:hidden px-4">
        <button
          onClick={handlePrint}
          className="flex items-center px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 shadow-sm transition-colors"
        >
          <Printer className="w-4 h-4 mr-2" />
          {language === 'marathi' ? 'Print' : 'Print'}
        </button>
        <button
          onClick={handleDownloadPdf}
          className="flex items-center px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 shadow-sm transition-colors"
        >
          <Download className="w-4 h-4 mr-2" />
          {language === 'marathi' ? 'Download PDF' : 'Download PDF'}
        </button>
      </div>

      <div className="w-full overflow-x-auto flex justify-center">
        <div ref={componentRef} className="bg-white text-black shadow-lg print:shadow-none relative" style={{ width: '210mm' }}>
          
          <div className="px-14 py-16 mx-auto relative box-border flex flex-col" style={{ width: '210mm', minHeight: '297mm', maxHeight: '297mm', overflow: 'hidden' }}>
            
            <div className="text-center mb-8 space-y-4">
              <p className="font-bold text-lg">{language === 'marathi' ? 'नमुना क्रमांक- १० (अ)' : 'Form No. 10 (A)'}</p>
              <p className="text-[15px]">{language === 'marathi' ? '(नियम १३ पाहा)' : '(See Rule 13)'}</p>
              <h1 className="text-xl font-bold border-b-[1.5px] border-black inline-block pb-0.5 mt-2">
                {language === 'marathi' ? 'जन्म / मृत्यू नोंदवही अनुउपलब्धता प्रमाणपत्र' : 'Non-availability Certificate of Birth/Death Register'}
              </h1>
              <p className="text-[15px] mt-3">{language === 'marathi' ? '(जन्म आणि मृत्यू नोंदणी अधिनियम, १९६९ च्या कलम १७ अन्वये दिलेले)' : '(Issued under Section 17 of the Registration of Births and Deaths Act, 1969)'}</p>
            </div>

            <div className="text-[15px] leading-loose mt-4">
               <div className="flex flex-wrap items-end mb-2">
                  <span className="mr-1">{language === 'marathi' ? 'प्रमाणित करण्यात येते की,' : 'This is to certify that, on the request of'}</span>
                  <span className="font-bold mr-1">{language === 'marathi' ? 'श्री./श्रीमती/ कुमारी' : 'Mr./Mrs./Miss'}</span>
                  <span className="border-b border-dashed border-black flex-grow"></span>
                  <span className="font-bold mx-1">{language === 'marathi' ? 'श्री.' : 'Mr.'}</span>
                  <span className="border-b border-dashed border-black w-24"></span>
               </div>
               <div className="flex flex-wrap items-end mb-8">
                  <span className="border-b border-dashed border-black w-64 mr-1"></span>
                  <span>{language === 'marathi' ? 'यांची/यांचा मुलगा/ पत्नी/ मुलगी यांच्या विनंतीवरुन' : 'his/her son/wife/daughter'}</span>
               </div>

               <div className="flex flex-wrap items-end mb-1">
                  <span className="font-bold mr-1">{language === 'marathi' ? 'श्री./श्रीमती/ कु.' : 'Mr./Mrs./Miss'}</span>
                  <span className="border-b border-dashed border-black flex-grow"></span>
                  <span className="ml-1">{language === 'marathi' ? 'यांचा/यांची पत्नी/मुलगा/मुलगी यांच्या' : "his/her wife/son/daughter's"}</span>
               </div>

               <div className="flex flex-wrap items-end mb-1">
                  <span className="mr-1">{language === 'marathi' ? 'जन्म / मृत्यु प्रमाणपत्रासाठी' : 'for birth / death certificate'}</span>
                  <span className="border-b border-dashed border-black w-64 mr-1"></span>
                  <span className="mr-1">{language === 'marathi' ? '(स्थानिक क्षेत्र) तहसील' : '(Local area) Tehsil'}</span>
                  <span className="border-b border-dashed border-black flex-grow"></span>
               </div>
               <div className="flex flex-wrap items-end mb-1">
                  <span className="mr-1">{language === 'marathi' ? 'जि.' : 'Dist.'}</span>
                  <span className="border-b border-dashed border-black w-64 mr-1"></span>
                  <span>{language === 'marathi' ? 'राज्य-महाराष्ट्र च्या नोंदणी अभिलेखाचा शोध घेण्यात आला आणि' : "State-Maharashtra's registration records were searched and"}</span>
               </div>
               <div className="flex flex-wrap items-end mb-1">
                  <span className="mr-1">{language === 'marathi' ? 'असे दिसून आले की,' : 'it was found that'}</span>
                  <span className="border-b border-dashed border-black w-48 mr-1"></span>
                  <span className="ml-1">{language === 'marathi' ? 'या वर्षाच्या मूळ जन्म/ मृत्यू नोंदवह्या उपलब्ध नाहीत.' : 'the original birth/death registers for this year are not available.'}</span>
               </div>
            </div>

            {/* Signatures area positioned towards the bottom of the content */}
            <div className="flex justify-end items-start mt-32 text-[15px]">
               <div className="w-1/2 flex flex-col items-center">
                  <p className="font-bold text-[15px] mb-8 text-center">{language === 'marathi' ? 'निर्गमित करणा-या प्राधिका-याची सही व दिनांक' : 'Signature and date of issuing authority'}</p>
                  <p className="text-[15px] font-bold">{language === 'marathi' ? 'सील' : 'Seal'}</p>
               </div>
            </div>

            <div className="absolute bottom-10 left-14 text-blue-700 text-sm underline print:hidden">
              www.majhigrampanchayat.com
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default JanmMrutyuNondvahiAnuplabdhataForm;
